import { debounce } from 'lodash';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/ProviderWorkPlace/ProviderWorkPlaceModel';
import { SearchInput } from '../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../customComponents/table/CustomTable';
import { RootState } from '../../../store';
import { ProviderWorkPlaceColumn } from './ProviderWorkPlaceColumn';
import './ProviderWorkPlaceTable.css';

const ProviderWorkPlaceTable: React.FC = () => {
  const dispatch = useDispatch();

  const reduxProviderWorkPlace = useSelector((state: RootState) => state?.models?.providerWorkPlace);
  const providerWorkPlaces = useSelector((state: RootState) => state?.store?.providerWorkPlace?.data ?? []);

  const pageSizes = [10, 20, 30, 50];
  const currentPage = Math.floor(reduxProviderWorkPlace?.props?.skip / reduxProviderWorkPlace?.props?.take) + 1;

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      dispatch(updateProps({ field: 'searchTerm', value }));
      dispatch(updateProps({ field: 'skip', value: 0 }));
    }, 500),
    [dispatch]
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  const handleEdit = useCallback((record: any) => {
    window.open(`/administration/providerWorkPlace/edit?id=${record?.id}`, '_blank');
  }, []);

  const paginationConfig = {
    current: currentPage,
    pageSize: reduxProviderWorkPlace?.props?.take,
    total: reduxProviderWorkPlace?.props?.totalItems,
    onChange: (page: number, pageSize: number) => {
      const skipValue = (page - 1) * pageSize;
      dispatch(updateProps({ field: 'skip', value: skipValue }));
      dispatch(updateProps({ field: 'take', value: pageSize }));
    },
    showSizeChanger: true,
    pageSizeOptions: pageSizes.map((size) => size.toString()),
    onShowSizeChange: (_current: number, size: number) => {
      dispatch(updateProps({ field: 'skip', value: 0 }));
      dispatch(updateProps({ field: 'take', value: size }));
    },
    showQuickJumper: false,
  };

  return (
    <>
      <SearchInput
        placeholder='Search...'
        defaultValue={reduxProviderWorkPlace?.props?.searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: 10 }}
      />
      <CustomTable
        initialDataSource={providerWorkPlaces}
        pagination={paginationConfig}
        columns={ProviderWorkPlaceColumn(handleEdit)}
        rowKey='id'
      />
    </>
  );
};

export default ProviderWorkPlaceTable;
